const getPortalUrls = () => {
  const hostname =
    typeof window !== "undefined" ? window.location.hostname : "";
  const isDemoEnv =
    hostname.includes("localhost") ||
    hostname.includes("127.0.0.1") ||
    hostname.includes(".dev.doubledot.es") ||
    hostname.includes("demo");

  if (isDemoEnv) {
    return {
      portalalumno: "https://portal-sanvalero.dev.doubledot.es/login/candidatos",
      portalalumnoofertas:
        "https://portal-sanvalero.dev.doubledot.es/ofertas-empleo",
      portalalumnoregistro:
        "https://portal-sanvalero.dev.doubledot.es/registro",
      portalempresas: "https://portal-sanvalero.dev.doubledot.es/login/empresas",
      portalempresasregistro:
        "https://portal-sanvalero.dev.doubledot.es/solicitar-cuenta",
      portaltutores: "http://tutores-sanvalero.dev.doubledot.es/",
    };
  }

  return {
    portalalumno: "https://candidatos.emplea2.net/",
    portalalumnoofertas: "https://candidatos.emplea2.net/ofertas-empleo",
    portalalumnoregistro: "https://candidatos.emplea2.net/registro",
    portalempresas: "https://empresas.emplea2.net",
    portalempresasregistro: "https://empresas.emplea2.net/solicitar-cuenta/",
    portaltutores: "https://tutores.emplea2.net/login/",
  };
};

const portalUrls = getPortalUrls();

export default {
  es: {
    enlaces: {
      contacto: "/contacto",
      tutores: "/servicios/tutores",
      titulados: "/servicios/titulados",
      empresas: "/servicios/empresas",
      colaboradores: "/colaboradores",
      programasyofertas: "/programas-y-ofertas",
      faqs: "/faqs",
      cookies: "/politica-de-cookies",
    },
    portalalumno: portalUrls.portalalumno,
    portalalumnoofertas: portalUrls.portalalumnoofertas,
    portalalumnoregistro: portalUrls.portalalumnoregistro,
    portalempresas: portalUrls.portalempresas,
    portalempresasregistro: portalUrls.portalempresasregistro,
    portaltutores: portalUrls.portaltutores,
  },
  en: {}
};



// WEBPACK FOOTER //
// ./src/translations/index.js